// src/images/Guardians/index.js
//
// Thumbnail images for the guardian selection screen.
//
// TO ADD THE IMAGES:
//   1. Drop the files in this folder, named g1.png ... g9.png
//      (any format the bundler handles is fine - .png, .jpg, .webp).
//   2. Uncomment the matching lines below.
//
// Until a file is added, the selection tile falls back to a generated
// gradient badge with the guardian's name, so the screen works either way
// and the build never breaks on a missing file.

export const GUARDIAN_IMAGES = {
  // g1: require('./g1.png'),
  // g2: require('./g2.png'),
  // g3: require('./g3.png'),
  // g4: require('./g4.png'),
  // g5: require('./g5.png'),
  // g6: require('./g6.png'),
  // g7: require('./g7.png'),
  // g8: require('./g8.png'),
  // g9: require('./g9.png'),
};

/**
 * @param {string} id Guardian id, e.g. "g3".
 * @returns {any|null} An image source usable by <Image source={...} />, or null.
 */
export function getGuardianImage(id) {
  if (!id) return null;
  return GUARDIAN_IMAGES[id] || null;
}

export default GUARDIAN_IMAGES;
